module.exports = __webpack_public_path__ + "img/iphone2@2x.33335f98.png";